import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import Paper from '@mui/material/Paper'
import Avatar from '@mui/material/Avatar'
import { useHomeContext } from '../../context'
import { Button } from '../../../../components/ui/button'
import { tokens } from '../../../../theme'

const Success = () => {
  const { t, handleReset } = useHomeContext()

  return (
    <Box sx={{ position: 'relative', zIndex: 10 }}>
      {/* Header */}
      <Box sx={{ pt: 1.5, pb: 1.5 }}>
        <Typography
          component="h1"
          sx={{
            fontFamily: 'Merriweather, serif',
            fontWeight: 900,
            fontSize: 32,
            lineHeight: '43px',
            letterSpacing: '1px',
            color: '#1C1C1E',
          }}
        >
          {t('success.title')} 🎉
        </Typography>

        <Typography
          sx={{
            fontFamily: 'Poppins, sans-serif',
            fontSize: 14,
            color: '#1C1C1E',
            lineHeight: 1.4,
            mt: 1,
          }}
        >
          {t('success.description')}{' '}
          <Box component="span" sx={{ fontWeight: 600 }}>
            {t('success.descriptionBold')}
          </Box>{' '}
          {t('success.descriptionEnd')}
        </Typography>
      </Box>

      {/* Just 2 Simple Steps Card */}
      <Paper
        elevation={0}
        sx={{
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          backdropFilter: 'blur(2px)',
          borderRadius: '16px',
          p: 1.5,
          mb: 1.5,
        }}
      >
        <Typography
          component="h2"
          sx={{
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 600,
            fontSize: 16,
            color: '#141414',
            letterSpacing: '-0.32px',
            mb: 1,
          }}
        >
          {t('success.stepsTitle')}
        </Typography>

        <Stack spacing={1.5}>
          {/* Step 1 */}
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Avatar
              sx={{
                width: 24,
                height: 24,
                bgcolor: tokens.colors.primary.main,
                fontSize: 12,
                fontWeight: 600,
                mt: 0.25,
              }}
            >
              1
            </Avatar>
            <Box>
              <Typography
                sx={{
                  fontFamily: 'Poppins, sans-serif',
                  fontWeight: 600,
                  fontSize: 14,
                  color: '#131313',
                  lineHeight: 1.5,
                }}
              >
                {t('success.step1Title')}
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'Poppins, sans-serif',
                  fontSize: 12,
                  color: '#131313',
                  lineHeight: 1.5,
                }}
              >
                {t('success.step1Description')} 🔔
              </Typography>
            </Box>
          </Box>

          {/* Step 2 */}
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Avatar
              sx={{
                width: 24,
                height: 24,
                bgcolor: tokens.colors.primary.main,
                fontSize: 12,
                fontWeight: 600,
                mt: 0.25,
              }}
            >
              2
            </Avatar>
            <Box>
              <Typography
                sx={{
                  fontFamily: 'Poppins, sans-serif',
                  fontWeight: 600,
                  fontSize: 14,
                  color: '#131313',
                  lineHeight: 1.5,
                }}
              >
                {t('success.step2Title')}
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'Poppins, sans-serif',
                  fontSize: 12,
                  color: '#131313',
                  lineHeight: 1.5,
                }}
              >
                {t('success.step2Description')}
              </Typography>
            </Box>
          </Box>
        </Stack>
      </Paper>

      {/* What Happens After Card */}
      <Paper
        elevation={0}
        sx={{
          backgroundColor: 'rgba(249, 247, 253, 0.6)',
          backdropFilter: 'blur(2px)',
          border: '1px solid #7349CD',
          borderRadius: '16px',
          p: 1.5,
          mb: 3,
        }}
      >
        <Typography
          sx={{
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 700,
            fontSize: 16,
            color: '#131313',
            lineHeight: '20px',
            mb: 1,
          }}
        >
          {t('success.whatHappens')}
        </Typography>
        <Typography
          sx={{
            fontFamily: 'Poppins, sans-serif',
            fontSize: 14,
            color: '#131313',
            lineHeight: 1.4,
            letterSpacing: '-0.42px',
          }}
        >
          {t('success.whatHappensDescription')}
        </Typography>
      </Paper>

      {/* CTA Button */}
      <Box>
        <Button onClick={handleReset}>{t('success.openNotification')}</Button>
        <Box sx={{ textAlign: 'center', mt: 1.5 }}>
          <Typography
            sx={{
              fontFamily: 'Poppins, sans-serif',
              fontWeight: 600,
              fontSize: 12,
              color: '#131313',
            }}
          >
            {t('success.cantFind')}
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Poppins, sans-serif',
              fontSize: 12,
              color: '#131313',
            }}
          >
            {t('success.refreshNote')}{' '}
            <Box
              component="a"
              href="https://tevi.com/@MEKOOMCN/messages"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: '#501BC0',
                textDecoration: 'underline',
                cursor: 'pointer',
              }}
            >
              {t('success.ourTeam')}
            </Box>
            .
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default Success
